import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { EScheduleSteps, saveSelectedDate, updateScheduleSteps } from '../../../../features/schedule/schedule-slice';
import { formatAvailableDaysByDatePicker } from '../../../../lib/dayjs';
import { Dialog, DialogContent, DialogTitle } from '../styled';
import { formatTitleByJourneyStatus } from '../utis';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { RootState } from '../../../../store';
import AvailableTimes from '../../Schedules/AvailableTimes';
import { IAppointments } from '../../../../services/availableTimes.service';
import AvailableAddress from '../AvailableAddress';
import { clearCalendarSelected } from '../../../../features/calendar/calendar-slice';

interface ISelectAvailableTimes {
  open: boolean;
  isLoading: boolean;
  appointments: IAppointments;
}

const SelectAvailableTimes = ({ open, isLoading, appointments }: ISelectAvailableTimes) => {
  const {
    schedule: {
      selectedDay,
      dateStart,
      ui: { previousStep }
    },
    calendar: { calendarsAvailables, calendarSelected },
    journey
  } = useSelector((state: RootState) => state);
  const [isValid, setIsValid] = useState<boolean>(false);
  const [duration, setDuration] = useState<string>('');
  const dispatch = useDispatch();
  const calendarWithOutAppointments = appointments.availableListAddress
    .filter(x => x[Object.keys(x)[0]].length === 0)
    .map(y => Object.keys(y)[0]);

  useEffect(() => {
    dispatch(saveSelectedDate(''));
  }, []);

  useEffect(() => {
    if (dateStart.length > 0 && calendarSelected) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [calendarSelected, dateStart]);

  useEffect(() => {
    if (calendarsAvailables.length === 0) return;
    const calendars = calendarSelected
      ? [calendarSelected]
      : calendarsAvailables.filter(item => !calendarWithOutAppointments.includes(item.id));
    const duration = calendars
      .map(item => item.durationEvent)
      .reduce((acc: number[], item: number) => {
        if (acc.includes(item)) {
          return acc;
        } else {
          acc.push(item);
          return acc;
        }
      }, []);
    const durationLabel =
      duration.length == 1 ? `${duration[0]} minutos` : `${Math.max(...duration)} a ${Math.min(...duration)} minutos`;
    setDuration(`duração do atendimento: ${durationLabel}`);
  }, [calendarsAvailables]);

  return (
    <Dialog open={open} scroll="paper">
      <DialogTitle>
        <CloseIcon
          onClick={() => {
            dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.idle, previousStep: EScheduleSteps.idle }));
            dispatch(clearCalendarSelected());
          }}
          sx={{
            cursor: 'pointer',
            mb: 3
          }}
        />

        <Typography variant="h3" sx={{ mb: 2 }} component={'div'}>
          {formatTitleByJourneyStatus(journey)}
        </Typography>
      </DialogTitle>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {formatAvailableDaysByDatePicker(selectedDay)}
      </Typography>
      <DialogContent>
        <AvailableTimes appointments={appointments} isLoading={isLoading} />
        <AvailableAddress appointments={appointments} />
        <Typography variant="body2R">{duration}</Typography>
      </DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<ArrowBackIcon />}
          onClick={() => {
            dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.openCalendar, previousStep: previousStep }));
          }}
        >
          Voltar
        </Button>
        <Button
          disabled={!isValid}
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={() => dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.confirmSchedule }))}
        >
          Continuar
        </Button>
      </Box>
    </Dialog>
  );
};

export default SelectAvailableTimes;
